exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{*{text-shadow:none!important}._2Wi5aGbyvdmxJ9{display:none}}", ""]);

// exports
exports.locals = {
	"noPrint": "_2Wi5aGbyvdmxJ9"
};